import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { services, companyInfo } from '../data/mock';
import { useLanguage } from '../contexts/LanguageContext';
import * as LucideIcons from 'lucide-react';

export const Services = () => {
  const { language, t } = useLanguage();
  
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${companyInfo.whatsapp}`, '_blank');
  };

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">{t.services.title}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service) => {
            const IconComponent = LucideIcons[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-amber-500"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-amber-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-amber-600 transition-colors">
                    <IconComponent className="w-8 h-8 text-amber-600 group-hover:text-white transition-colors" />
                  </div>
                  <CardTitle className="text-2xl">{service.title[language]}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">{service.description[language]}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Process Section */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t.services.processTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {t.services.process.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-amber-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                  0{index + 1}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t.services.differentialsTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {t.services.differentials.map((item, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-br from-amber-600 to-amber-700 rounded-2xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">{t.services.ctaTitle}</h2>
          <p className="text-xl text-amber-100 mb-8 max-w-2xl mx-auto">
            {t.services.ctaSubtitle}
          </p>
          <Button
            onClick={handleWhatsAppClick}
            size="lg"
            className="bg-white text-amber-600 hover:bg-gray-100 text-lg px-8 py-6 transition-colors"
          >
            <Phone className="w-5 h-5 mr-2" />
            {t.services.ctaButton}
          </Button>
        </div>
      </div>
    </div>
  );
};